"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.vehiclesSearchQueryData = void 0;
exports.vehiclesSearchQueryData = [
    {
        path: '/pim/vehicles/peugeot/partner/mester',
        matchingVariant: {
            sku: 'K9L1SH100M',
        },
    },
    {
        path: '/pim/vehicles/peugeot/e208/e208-allure-2',
        matchingVariant: {
            sku: 'P21ALLEL',
        },
    },
    {
        path: '/pim/vehicles/peugeot/e208/e208-allure-1',
        matchingVariant: {
            sku: 'P21ALLEV D0QU',
        },
    },
    {
        path: '/pim/vehicles/peugeot/e208/e208-gt-line',
        matchingVariant: {
            sku: 'P21GTLEV MSZ9',
        },
    },
    {
        path: '/pim/vehicles/peugeot/e208/e208-gt',
        matchingVariant: {
            sku: 'P21GTEL NMLO',
        },
    },
    {
        path: '/pim/vehicles/kia/e-soul-392kw/classic-392-kw',
        matchingVariant: {
            sku: 'J2W5ZGZ7Z D079',
        },
    },
    {
        path: '/pim/vehicles/peugeot/e208/e208-gt-pack',
        matchingVariant: {
            sku: 'P21GTPEL MOO-',
        },
    },
    {
        path: '/pim/vehicles/peugeot/e2008/e2008-allure',
        matchingVariant: {
            sku: 'P24ALLEL HF88',
        },
    },
    {
        path: '/pim/vehicles/kia/e-soul-392kw/active-392-kw',
        matchingVariant: {
            sku: 'J2W5ZGZ7Z G610',
        },
    },
    {
        path: '/pim/vehicles/peugeot/e2008/e2008-gt',
        matchingVariant: {
            sku: 'P24GTEL MV2O',
        },
    },
    {
        path: '/pim/vehicles/peugeot/e2008/e2008-gt-pack',
        matchingVariant: {
            sku: 'P24GTPEL AHFE',
        },
    },
    {
        path: '/pim/vehicles/kia/e-niro-72kw/active-72-kw',
        matchingVariant: {
            sku: 'DQW5ZGZ7Z GALG',
        },
    },
    {
        path: '/pim/vehicles/kia/e-soul-392kw/exclusive-392-kw',
        matchingVariant: {
            sku: 'J2W5ZGZ7Z G612',
        },
    },
    {
        path: '/pim/vehicles/kia/e-niro-11kw/active-11-kw',
        matchingVariant: {
            sku: 'DQW5ZGZ7Z GALI',
        },
    },
    {
        path: '/pim/vehicles/kia/e-soul-64kw-72kw/classic-64-kw-72-kw',
        matchingVariant: {
            sku: 'J2W5ZGZ7Z D273',
        },
    },
    {
        path: '/pim/vehicles/kia/e-soul-64kw-72kw/exclusive-64-kw-72-kw',
        matchingVariant: {
            sku: 'J2W5ZGZ7Z G542',
        },
    },
    {
        path: '/pim/vehicles/kia/e-soul-392kw/exclusive-392-kw-msoltak',
        matchingVariant: {
            sku: 'J2W5ZGZ7Z G613',
        },
    },
    {
        path: '/pim/vehicles/kia/e-niro-72kw/active-mteknikkpakke-72-kw-1',
        matchingVariant: {
            sku: 'DQW5ZGZ7Z GABM',
        },
    },
    {
        path: '/pim/vehicles/kia/e-niro-72kw/active-mteknikkpakke-72-kw',
        matchingVariant: {
            sku: 'DQW5ZGZ7Z GALH',
        },
    },
    {
        path: '/pim/vehicles/kia/e-soul-64kw-11kw/exclusive-64-kw-11kw',
        matchingVariant: {
            sku: 'J2W5ZGZ7Z G543',
        },
    },
    {
        path: '/pim/vehicles/kia/e-soul-64kw-72kw/exclusive-64-kw-msoltak-72-kw',
        matchingVariant: {
            sku: 'J2W5ZGZ7Z G616',
        },
    },
    {
        path: '/pim/vehicles/kia/e-soul-64kw-72kw/exclusive-64-kw-suv-72-kw',
        matchingVariant: {
            sku: 'J2W5ZGZ7Z G544',
        },
    },
    {
        path: '/pim/vehicles/kia/e-niro-11kw/active-mteknikkpakke-11-kw',
        matchingVariant: {
            sku: 'DQW5ZGZ7Z GALJ',
        },
    },
    {
        path: '/pim/vehicles/kia/e-soul-64kw-11kw/exclusive-64-kw-msoltak-11-kw',
        matchingVariant: {
            sku: 'J2W5ZGZ7Z G617',
        },
    },
    {
        path: '/pim/vehicles/kia/e-soul-64kw-11kw/exclusive-64-kw-suv-11-kw',
        matchingVariant: {
            sku: 'J2W5ZGZ7Z G545',
        },
    },
    {
        path: '/pim/vehicles/kia/e-soul-64kw-72kw/active-64-kw-72-kw',
        matchingVariant: {
            sku: 'J2W5ZGZ7Z G611',
        },
    },
    {
        path: '/pim/vehicles/kia/e-niro-72kw/exclusive-uskinn-72-kw',
        matchingVariant: {
            sku: 'DQW5ZGZ7Z GALK',
        },
    },
    {
        path: '/pim/vehicles/kia/e-soul-64kw-11kw/exclusive-64-kw-suv-msoltak-11-kw',
        matchingVariant: {
            sku: 'J2W5ZGZ7Z G546',
        },
    },
    {
        path: '/pim/vehicles/kia/e-niro-11kw/exclusive-uskinn-11-kw',
        matchingVariant: {
            sku: 'DQW5ZGZ7Z GALL',
        },
    },
    {
        path: '/pim/vehicles/kia/e-niro-72kw/exclusive-mskinn-72-kw-1',
        matchingVariant: {
            sku: 'DQW5ZGZ7Z GALM',
        },
    },
    {
        path: '/pim/vehicles/kia/e-niro-72kw/exclusive-mskinn-72-kw',
        matchingVariant: {
            sku: 'DQW5ZGZ7Z GAH0',
        },
    },
    {
        path: '/pim/vehicles/kia/e-niro-11kw/exclusive-mskinn-uminne-11-kw',
        matchingVariant: {
            sku: 'DQW5ZGZ7Z GABS',
        },
    },
    {
        path: '/pim/vehicles/kia/e-niro-11kw/exclusive-mskinn-11kw',
        matchingVariant: {
            sku: 'DQW5ZGZ7Z GALN',
        },
    },
    {
        path: '/pim/vehicles/kia/e-niro-11kw/exclusive-mskinn-12',
        matchingVariant: {
            sku: 'DQW5ZGZ7Z GAH1',
        },
    },
    {
        path: '/pim/vehicles/kia/e-niro-72kw/exclusive-mskinn-and-soltak-72-kw',
        matchingVariant: {
            sku: 'DQW5ZGZ7Z GALO',
        },
    },
    {
        path: '/pim/vehicles/kia/e-niro-72kw/exclusive-mskinn-and-soltak-uminne-72-kw',
        matchingVariant: {
            sku: 'DQW5ZGZ7Z GABT',
        },
    },
    {
        path: '/pim/vehicles/kia/e-niro-11kw/exclusive-mskinn-and-soltak-11-kw',
        matchingVariant: {
            sku: 'DQW5ZGZ7Z GAH3',
        },
    },
    {
        path: '/pim/vehicles/kia/e-niro-11kw/exclusive-mskinn-and-soltak-11-kw-1',
        matchingVariant: {
            sku: 'DQW5ZGZ7Z GALP',
        },
    },
    {
        path: '/pim/vehicles/kia/e-niro-11kw/exclusive-mskinn-and-soltak-uminne-11-kw',
        matchingVariant: {
            sku: 'DQW5ZGZ7Z GABU',
        },
    },
    {
        path: '/pim/vehicles/peugeot/3008-15-bluehdi/3008-allure-15-bluehdi-130-hk-aut',
        matchingVariant: {
            sku: 'P84ALL130HA8 P=HP',
        },
    },
    {
        path: '/pim/vehicles/peugeot/5008/5008-allure-15-bluehdi-130-hk-aut',
        matchingVariant: {
            sku: 'P87ALL130HA8 PI5I',
        },
    },
    {
        path: '/pim/vehicles/peugeot/3008-15-bluehdi/3008-gt-15-bluehdi-130-hk-aut',
        matchingVariant: {
            sku: 'P84GT130HA8 PI5-',
        },
    },
    {
        path: '/pim/vehicles/peugeot/3008-phev/3008-allure-phev-300-hk-eat8',
        matchingVariant: {
            sku: 'P84ALLHYB4 Q6NY',
        },
    },
    {
        path: '/pim/vehicles/peugeot/5008/5008-gt-15-bluehdi-130-hk-aut',
        matchingVariant: {
            sku: 'P87GT130HA8 PI5-',
        },
    },
    {
        path: '/pim/vehicles/peugeot/3008-phev/3008-gt-phev-300-hk-eat8',
        matchingVariant: {
            sku: 'P84GTHYB4 P.0T',
        },
    },
    {
        path: '/pim/vehicles/mercedes-benz/eqc/eqc400-amg-edition',
        matchingVariant: {
            sku: 'EQC400 4M NO6',
        },
    },
    {
        path: '/pim/vehicles/mercedes-benz/eqc/eqc400-amg-edition-plus',
        matchingVariant: {
            sku: 'EQC400 4M NO7',
        },
    },
    {
        path: '/pim/vehicles/mercedes-benz/eqc/eqc400-amg-edition-premium',
        matchingVariant: {
            sku: 'EQC400 4M NO8',
        },
    },
    {
        path: '/pim/vehicles/mercedes-benz/eqc/eqc400-amg-edition-premium-plus',
        matchingVariant: {
            sku: 'EQC400 4M NO9',
        },
    },
    {
        path: '/pim/vehicles/mercedes-benz/glc-phev-bensin/glc-300-e-4m-amg-edition',
        matchingVariant: {
            sku: 'GLC300E NO6',
        },
    },
    {
        path: '/pim/vehicles/mercedes-benz/e-klasse/e300det-4m-amg-edition',
        matchingVariant: {
            sku: 'E300T D E 4M NO6',
        },
    },
    {
        path: '/pim/vehicles/mercedes-benz/glc-phev-diesel/glc300de-4m-amg-edition',
        matchingVariant: {
            sku: 'GLC300DE NO7',
        },
    },
    {
        path: '/pim/vehicles/mercedes-benz/e-klasse/e300det-4m-amg-edition-plus',
        matchingVariant: {
            sku: 'E300T D E 4M NO7',
        },
    },
    {
        path: '/pim/vehicles/mercedes-benz/e-klasse/e300det-4m-amg-edition-premium-plus',
        matchingVariant: {
            sku: 'E300T D E 4M NO8',
        },
    },
    {
        path: '/pim/vehicles/mercedes-benz/gle/gle350d-e-4m-amg-edition',
        matchingVariant: {
            sku: 'GLE350D E NO6',
        },
    },
    {
        path: '/pim/vehicles/mercedes-benz/gle/gle350d-e-4m-amg-edition-plus',
        matchingVariant: {
            sku: 'GLE350D E NO7',
        },
    },
];
//# sourceMappingURL=vehicle-search.js.map